import { apiBackOffice, apiCadastro } from './utils/api';

export const getEquipeVenda = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/EquipeVenda`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getEscritorioVenda = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/EscritorioVenda`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getAreaVendaVendedor = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/AreaVendaVendedor`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getTrilha = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/Trilha`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getCanalDistribuicao = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/CanalDistribuicao`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getCidade = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/Cidade`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getContexto = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/Contexto`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getEmpresa = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/Empresa`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getEstado = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/Estado`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getFamiliaMaterial = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/FamiliaMaterial`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getFilial = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/Filial`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getGrupoCentralizador = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/GrupoCentralizador`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getGrupoMaterial = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/GrupoMaterial`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getSubGrupoMaterial = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/SubGrupoMaterial`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getGrupoSegmento = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/GrupoSegmento`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getLocal = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/Local`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getLocalTrilha = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/LocalTrilha`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getVendedor = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/Vendedores`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getPrazoPagamento = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/PrazoPagamento`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getSimulacao = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/Simulacao`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getTipoCondicao = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/TipoCondicao`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getSegmento = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/Segmento`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getUnidadeMedida = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/UnidadeMedida`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getMotivo = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/Motivo`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getParametro = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/Parametro`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getHierarquiaAprovacao = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/HierarquiaAprovacao`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getPesquisaCanalDistribuicao = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/PesquisaCanalDistribuicao`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getPesquisaMotivoCompra = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/PesquisaMotivoCompra`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getPesquisaGrupoMaterialCanalDistribuicao = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/PesquisaGrupoMaterialCanalDistribuicao`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getPesquisaUnidadeMedida = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/PesquisaUnidadeMedida`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getPesquisaPlayer = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/PesquisaPlayer`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getPesquisaGrupoMaterialPlayer = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/PesquisaGrupoMaterialPlayer`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getPesquisaPrazo = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/PesquisaPrazo`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getPesquisaGrupoMaterialPrazo = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/PesquisaGrupoMaterialPrazo`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getPesquisaPlayerCentroOrigem = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/PesquisaPlayerCentroOrigem`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getPesquisaProdutos = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/PesquisaProdutos`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getPesquisaEmbalagem = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/PesquisaEmbalagem`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getPesquisaGrupoMaterial = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/PesquisaGrupoMaterial`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getPesquisaGrupoMaterialUnidadeMedida = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/PesquisaGrupoMaterialUnidadeMedida`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getPesquisaGrupoMaterialEmbalagem = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/PesquisaGrupoMaterialEmbalagem`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getPesquisaCentroOrigem = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/PesquisaCentroOrigem`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getPesquisaGruposObrigatorios = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/PesquisaGruposObrigatorios`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getProdutoFilial = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/ProdutoFilial`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getServico = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/Servico`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getPrecoCliente = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/PrecoCliente`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getPrecoRegra = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/PrecoRegra`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getPrazoRegra = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/PrazoRegra`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}
export const getProduto = async (skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/Produto`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const buscaCepsRegiao = async (skip, take, dataAtualizacao, regiao) => {
  const res = await apiCadastro.get(`/api/Endereco/Ceps/Regiao/${regiao}`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response);
  return res;
}

export const getDocumentos = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/Documentos`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getUltimosUploadsDocumentos = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/UltimosUploadsCredito`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getFunilObraProdutos = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/FunilObraProduto`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getFunilObras = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/FunilObra`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getFunilObraGrupoProdutos = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/FunilObraGrupoProduto`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getProdutosConcorrente = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/ProdutoConcorrente`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getFunilObraUnidadeMedidas = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/FunilObraUnidadeMedida`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getFunilObraGrupoProdutoUnidadeMedida = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/FunilObraGrupoProdutoUnidadeMedida`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getFunilObraMotivoPerda = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/FunilObraMotivoPerda`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getFunilObraGrupoProdutoMapeamentoInicial = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/FunilObraGrupoProdutoMapeamentoInicial`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getCargos = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/Cargo`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getClusters = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/Cluster`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getMicrorregiao = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/Microrregiao`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getFunilStatus = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/FunilStatus`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getReflex = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice
    .get(`/api/Sincronizacao/Reflex`, {
      params: { take, skip, dataAtualizacao, usuarioId: vendedorSelecionado },
    })
    .then((response) => response);
  return res;
};

export const getPosicaoCarga = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice
    .get(`/api/Sincronizacao/PosicaoCarga`, {
      params: { take, skip, dataAtualizacao, usuarioId: vendedorSelecionado },
    })
    .then((response) => response);
  return res;
};

export const getAutosservico = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice
    .get(`/api/Sincronizacao/Autosservico`, {
      params: { take, skip, dataAtualizacao, usuarioId: vendedorSelecionado },
    })
    .then((response) => response);
  return res;
};

export const getCreditoCliente = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice
    .get(`/api/Sincronizacao/CreditoCliente`, {
      params: { take, skip, dataAtualizacao, usuarioId: vendedorSelecionado },
    })
    .then((response) => response);
  return res;
};

export const getForcaVenda = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice
    .get(`/api/Sincronizacao/ForcaVenda`, {
      params: { take, skip, dataAtualizacao, usuarioId: vendedorSelecionado },
    })
    .then((response) => response);
  return res;
};

export const getErroPesquisa = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice
    .get(`/api/Sincronizacao/ErroPesquisa`, {
      params: { take, skip, dataAtualizacao, usuarioId: vendedorSelecionado },
    })
    .then((response) => response);
  return res;
};

export const getErroPesquisaVendedor = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice
    .get(`/api/Sincronizacao/ErroPesquisaVendedor`, {
      params: { take, skip, dataAtualizacao, usuarioId: vendedorSelecionado },
    })
    .then((response) => response);
  return res;
};

export const getBateuLevou = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice
    .get(`/api/Sincronizacao/BateuLevou`, {
      params: { take, skip, dataAtualizacao, usuarioId: vendedorSelecionado },
    })
    .then((response) => response);
  return res;
};

export const getSuper4 = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice
    .get(`/api/Sincronizacao/Super4`, {
      params: { take, skip, dataAtualizacao, usuarioId: vendedorSelecionado },
    })
    .then((response) => response);
  return res;
};

export const getVloz = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice
    .get(`/api/Sincronizacao/Vloz`, {
      params: { take, skip, dataAtualizacao, usuarioId: vendedorSelecionado },
    })
    .then((response) => response);
  return res;
};

export const getPassouGanhou = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice
    .get(`/api/Sincronizacao/PassouGanhou`, {
      params: { take, skip, dataAtualizacao, usuarioId: vendedorSelecionado },
    })
    .then((response) => response);
  return res;
};

export const getGvFaturamento = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice
    .get(`/api/Sincronizacao/GvFaturamento`, {
      params: { take, skip, dataAtualizacao, usuarioId: vendedorSelecionado },
    })
    .then((response) => response);
  return res;
};

export const getClienteShare = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice
    .get(`/api/Sincronizacao/ClienteShare`, {
      params: { take, skip, dataAtualizacao, usuarioId: vendedorSelecionado },
    })
    .then((response) => response);
  return res;
};

export const getParametroReflex = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice
    .get(`/api/Sincronizacao/ParametroReflex`, {
      params: { take, skip, dataAtualizacao, usuarioId: vendedorSelecionado },
    })
    .then((response) => response);
  return res;
};


export const getGov = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/Gov`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getFunilStatusGrupo = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/FunilStatusGrupo`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getFunilObraFonteCaptacao = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/FunilObraFonteCaptacao`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getFunilObraJustificativa = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/FunilObraJustificativa`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getTabelaPreco = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/TabelaPreco`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getTabelaPrecoCliente = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/TabelaPrecoCliente`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getRota = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/Rota`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getRotaDoDia = async () => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/RotaDoDia`).then((response) => response);
  return res;
}

export const getInfoTatica = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/InfoTatica`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getMissao = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/Missao`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getFaturamento = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/Faturamento`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getVisita = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/Visita`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getUltimaVisita = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/UltimaVisita`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getMapaMina = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/MapaMina`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getCarteira = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/Carteira`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getMotivoPerda = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/MotivoPerda`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getFunilObraConcorrente = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/FunilObraConcorrente`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getFunilObraConsorcio = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/FunilObraConsorcio`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getFunilObraEmpresaLider = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/FunilObraEmpresaLider`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getNivelServico = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/NivelServico`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}

export const getDuplaCategoria = async (take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const res = await apiBackOffice.get(`/api/Sincronizacao/DuplaCategoria`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao, usuarioId: vendedorSelecionado } }).then((response) => response);
  return res;
}